module.exports = __webpack_public_path__ + "img/co-branding-tab.3f030921.gif";